<template>
  <div class="nav-wrapper nav">
      <router-link :to="{ name: 'PackingList' }">
        <span class="material-symbols-outlined">arrow_back_ios_new</span>BACK</router-link
      >
    </div>
</template>

<script>
export default {
  name:'PackingListNav'
}
</script>

<style lang='scss' scoped>
.nav-wrapper {
  width: 100%;
  margin: 20px 0px;
  margin-left: -10px;
  @include respond-to('sm') {
    width: 66%;
  }
  &.nav {
    text-align: left;
    .material-symbols-outlined {
      font-size: 16px;
      position: relative;
      top: 2px;
      color: black;
    }
  }
  &.nav a {
    color: black;
  }
}
</style>